import React from 'react';
import CKEditorJuanaManso from '../CkeditorJuanaManso';

const CKEditorCopete = (props) => {
  const configCkeditorCopete = {
    height: 200,
    toolbar: [
      { name: 'heading', items: ['Format'] },
      { name: 'basicstyles', items: ['Bold', 'Italic'] },
      { name: 'styles', items: ['TextColor', 'BGColor', 'Font'] },
      { name: 'editing', items: ['Find', 'Replace', 'SelectAll', '-', 'Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
    ],
    format_tags: 'p',
  };

  return (
    <div>
      <CKEditorJuanaManso
        configParent={configCkeditorCopete}
        {...props}
      />
    </div>
  );
};

export default CKEditorCopete;
